import React, { useState } from "react";
import { Alert, Box, Button, CircularProgress, Grid, Snackbar, Typography } from "@mui/material";
import DashboardLayout from "app/layout/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/layout/DashboardNavbar";
import HeaderCamaras from "./components/HeaderCamaras";
import TableCamaras from "./components/TableCamaras";
import CameraDetailModal from "./components/CameraDetailModal";
import { useCamaras } from "./hooks/useCamaras";
import { formatCameraDate } from "./model/cameraModel";

function Camaras() {
  const data = useCamaras();
  const [notice, setNotice] = useState(null);
  const refresh = async () => {
    const result = await data.refreshData();
    if (result)
      setNotice({
        severity: result.success ? "success" : "error",
        message: result.success ? "Listado actualizado correctamente." : result.error,
      });
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box sx={{ py: 3, color: "#254258" }}>
        <HeaderCamaras
          comercios={data.comercios}
          camarasDelComercio={data.camarasDelComercioSeleccionado}
          comercioSeleccionado={data.comercioSeleccionado}
          camaraSeleccionada={data.camaraSeleccionada}
          filtros={data.filtros}
          loading={data.loading.initial}
          checkingStatus={data.loading.cameraStatus}
          onRefresh={refresh}
          onConsultar={data.consultarEstadoCamara}
          onSeleccionarComercio={data.seleccionarComercio}
          onSeleccionarCamara={data.seleccionarCamara}
          onFiltroChange={data.setFiltro}
          onClearFilters={data.clearFilters}
        />
        <Grid container spacing={2} sx={{ my: 1 }}>
          {[
            ["Cámaras en la vista", data.stats.totalCamaras, "#edf3fb", "#315e89"],
            ["Con alcance", data.stats.disponibles, "#eaf6ef", "#226346"],
            ["Sin alcance", data.stats.sinAlcance, "#fceef0", "#a33948"],
            ["Sin verificar", data.stats.desconocidas, "#f0f2f6", "#59677d"],
          ].map(([label, value, bg, color]) => (
            <Grid item xs={6} md={3} key={label}>
              <Box sx={{ bgcolor: bg, borderRadius: 2, p: 2, border: `1px solid ${color}25` }}>
                <Typography sx={{ color, fontSize: 26, fontWeight: 700 }}>{value}</Typography>
                <Typography sx={{ color, fontSize: 13, fontWeight: 600 }}>{label}</Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
        <Typography sx={{ my: 2, fontSize: 12, color: "#60788c" }}>
          Los contadores corresponden a los filtros actuales. Última actualización del listado:{" "}
          {formatCameraDate(data.lastUpdated)}
          {data.lastUpdated ? " · Colombia" : ""}
        </Typography>
        {data.error && (
          <Alert
            severity="error"
            sx={{ mb: 2 }}
            action={
              <Button disabled={data.loading.initial} color="inherit" onClick={refresh}>
                Reintentar
              </Button>
            }
          >
            {data.error}
            {data.lastUpdated ? " Se conserva el último listado cargado." : ""}
          </Alert>
        )}
        {data.loading.initial ? (
          <Box sx={{ py: 8, textAlign: "center" }}>
            <CircularProgress />
            <Typography sx={{ mt: 2, fontSize: 14 }}>Cargando cámaras…</Typography>
          </Box>
        ) : (
          <TableCamaras
            camaras={data.camaras}
            checkingStatus={data.loading.cameraStatus}
            onConsultar={data.consultarEstadoCamara}
          />
        )}
        <CameraDetailModal
          open={data.modalAbierto}
          onClose={data.cerrarModal}
          detalle={data.detalleCamara}
          loading={data.loading.cameraStatus}
          errorConsulta={data.errorConsulta}
          imagenCamara={data.imagenCamara}
          cargandoImagen={data.cargandoImagen}
          errorImagen={data.errorImagen}
          onReintentarImagen={data.consultarImagenCamara}
          onConsultar={data.consultarEstadoCamara}
        />
        <Snackbar open={!!notice} autoHideDuration={5000} onClose={() => setNotice(null)}>
          <Alert severity={notice?.severity || "info"} onClose={() => setNotice(null)}>
            {notice?.message}
          </Alert>
        </Snackbar>
      </Box>
    </DashboardLayout>
  );
}
export default Camaras;
